// SearchSpring Bundle Variant Selector Script
  (function() {

    // SearchSpring Variant Selector Injection for Bundle Products
    function injectBundleVariantSelectors() {
      // Wait for SearchSpring to load and render products
      const observer = new MutationObserver((mutations, obs) => {
        // Look for SearchSpring product cards - updated selectors
        const productCards = document.querySelectorAll('.ss__result, .ss__result__inner, [data-ss-result], .grid-product, [data-product-id]');
        
        if (productCards.length > 0) {
          productCards.forEach(card => {
            // Skip if we already processed this card
            if (card.classList.contains('ss-bundle-processed')) return;
            
            // Check if this is a bundle product
            const isBundle = checkIfBundle(card);
            
            if (isBundle) {
              processCard(card);
            }
          });
        }
      });
      
      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Also run immediately after delays
      setTimeout(() => {
        const productCards = document.querySelectorAll('.ss__result, .ss__result__inner, [data-ss-result], .grid-product, [data-product-id]');
        
        productCards.forEach(card => {
          if (card.classList.contains('ss-bundle-processed')) return;
          
          const isBundle = checkIfBundle(card);
          
          if (isBundle) {
            processCard(card);
          }
        });
      }, 1500);
      
      // Re-run on SearchSpring events
      setTimeout(() => {
        const productCards = document.querySelectorAll('.ss__result, .ss__result__inner, [data-ss-result], .grid-product, [data-product-id]');
        productCards.forEach(card => {
          if (card.classList.contains('ss-bundle-processed')) return;
          
          const isBundle = checkIfBundle(card);
          
          if (isBundle) {
            processCard(card);
          }
        });
      }, 3000);
    }
    
    function checkIfBundle(card) {
      // Check product title for "Bundle" - SearchSpring specific selectors
      const titleSelectors = [
        '.ss__result__name',
        '.grid-product__title',
        '[data-ss-title]',
        '.product-title',
        'a[href*="/products/"]'
      ];
      
      let title = '';
      for (const selector of titleSelectors) {
        const titleElement = card.querySelector(selector);
        if (titleElement) {
          title = titleElement.textContent || titleElement.getAttribute('data-ss-title') || '';
          if (title.trim()) {
            break;
          }
        }
      }
      
      // Check if title contains "bundle" (case insensitive)
      if (title.toLowerCase().includes('bundle')) {
        return true;
      }
      
      // Check for shopify-bundle tag in data attributes
      const tags = card.getAttribute('data-tags') || 
                   card.getAttribute('data-ss-tags') || 
                   card.getAttribute('data-product-tags') ||
                   '';
      if (tags.toLowerCase().includes('shopify-bundle')) {
        return true;
      }
      
      return false;
    }
    
    function processCard(card) {
      // Skip if already processed
      if (card.classList.contains('ss-bundle-processed')) return;
      
      // Find product link to get the URL
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      
      const productUrl = productLink.getAttribute('href');
      
      // Find the Quick Add button
      const addButton = card.querySelector('.pop-over-single-quick-add, button[value="Add To Cart"], .quick-add-btn, button[name="add"]');
      
      if (!addButton) return;
      
      // Mark as processed
      card.classList.add('ss-bundle-processed');
      
      // Change button text to "VIEW MORE"
      addButton.textContent = 'VIEW MORE';
      addButton.innerHTML = 'VIEW MORE';
      
      // Remove any existing click handlers
      const newButton = addButton.cloneNode(true);
      addButton.parentNode.replaceChild(newButton, addButton);
      
      // Add click handler to go to product page
      newButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = productUrl;
      });
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectBundleVariantSelectors);
    } else {
      injectBundleVariantSelectors();
    }
    
    // Also re-run when SearchSpring updates (pagination, filtering, etc.)
    function handleSearchSpringUpdate() {
      document.querySelectorAll('.ss-bundle-processed').forEach(card => {
        card.classList.remove('ss-bundle-processed');
      });
      injectBundleVariantSelectors();
    }
    
    window.addEventListener('searchspring.domReady', handleSearchSpringUpdate);
    document.addEventListener('searchspring.domReady', handleSearchSpringUpdate);
  })();